var util = require("./util");
var a11y = require("./a11y");
var placementMap = {
    block: "/Block",
    inline: "/Inline",
    before: "/Before",
    start: "/Start",
    end: "/End",
};
function PDFImage(options) {
    options = options || {};
    // TODO: validate the inputs
    this.src = util.getOption(options, "src", null);
    this.width = util.getOption(options, "width", "auto");
    this.height = util.getOption(options, "height", "auto");
    this.srcWidth = util.getOption(options, "srcWidth", null);
    this.srcHeight = util.getOption(options, "srcHeight", null);
    this.align = util.getOption(options, "align", "left");
    this.verticalAlign = util.getOption(options, "align", "top");
    this.drawHook = util.getOption(options, "drawHook", null);
    this.role = options.role === "none" ? null : "img";
    this.alt = util.getOption(options, "alt", "");
    this.placement = util.getOption(options, "placement", null);
    this.a11yAttr = util.getOption(options, "a11yAttr", {});
    if (!this.src)
        throw new Error("PDF image: src is required");
    if (this.width === "auto" && !this.srcWidth && !this.srcHeight)
        throw new Error("PDF image: if width is 'auto', then srcWidth and srcHeight are required.");
    if (this.height === "auto" && !this.srcWidth && !this.srcHeight)
        throw new Error("PDF image: if height is 'auto', then srcWidth and srcHeight are required.");
}
PDFImage.prototype.calc = function (cursor) {
    var calcWidth = this.width;
    if (typeof calcWidth.pct === "number")
        calcWidth = cursor.width * calcWidth.pct;
    var calcHeight = this.height;
    if (typeof calcHeight.pct === "number")
        calcHeight = cursor.height * calcHeight.pct;
    if (this.width === "auto" && this.height === "auto") {
        calcWidth = this.srcWidth;
        calcHeight = this.srcHeight;
    }
    else if (this.width === "100%") {
        calcWidth = cursor.width;
        if (this.height === "auto")
            calcHeight = calcWidth * this.getRatio();
    }
    else if (this.width === "auto") {
        calcWidth = calcHeight / this.getRatio();
    }
    else if (this.height === "auto") {
        calcHeight = calcWidth * this.getRatio();
    }
    return {
        width: calcWidth,
        height: calcHeight,
    };
};
PDFImage.prototype.getRatio = function () {
    return this.srcHeight / this.srcWidth;
};
PDFImage.prototype.draw = function (cursor) {
    var _calc = this.calc(cursor);
    var box = {
        x: cursor.x,
        y: cursor.y,
        width: _calc.width,
        height: _calc.height,
    };
    var imgType = "JPEG";
    if (/^data:image\/png;/i.test(this.src))
        imgType = "PNG";
    if (this.align === "right")
        box.x = cursor.x + cursor.width - box.width;
    if (this.align === "center")
        box.x = cursor.x + (cursor.width - box.width) / 2;
    if (this.verticalAlign === "bottom")
        box.y = cursor.y + cursor.height - box.height;
    if (this.verticalAlign === "middle")
        box.y = cursor.y + (cursor.height - box.height) / 2;
    var shouldContinue = true;
    if (this.drawHook) {
        var e = {
            preventDefault: function () {
                shouldContinue = false;
            },
        };
        this.drawHook.call(this, e, cursor, box);
        if (!shouldContinue)
            return;
    }
    if (this.role) {
        var attr = util.extend(false, {
            O: "/Layout",
            BBox: cursor.doc.convertBBox(box.x, box.y, box.width, box.height),
        }, this.a11yAttr);
        if (this.placement && placementMap[this.placement]) {
            attr.Placement = placementMap[this.placement];
        }
        a11y.structure(cursor, "img", {
            alt: this.alt,
            attr: attr,
        }, function () {
            a11y.marked(cursor, function () {
                cursor.doc.addImage(this.src, imgType, box.x, box.y, box.width, box.height);
            }, null, this);
        }, this);
    }
    else {
        a11y.artifact(cursor, function () {
            cursor.doc.addImage(this.src, imgType, box.x, box.y, box.width, box.height);
        }, this);
    }
    return {
        width: box.width,
        height: box.height,
    };
};
module.exports = PDFImage;
//# sourceMappingURL=module.js.map